import React, { useState, useRef, useEffect } from "react";

function VnirSatCanvas(props) {

	const [canvasWidth, setCanvasWidth] = useState(0);
	const [canvasHeight, setCanvasHeight] = useState(0);

  const canvasRef = useRef(null);
  const wrapperRef = useRef(null);

  var isDown = false;

  var startX = 0;
  var startY = 0;

  var mouseX = 0;
  var mouseY = 0;

  var x1;
  var y1;
  var x2;
  var y2;
  
  var model_name = props.model_name ? props.model_name :'Auto ROI'

  /* ************************************************************************* */
  useEffect(() => {
    /* THT: Added some hacky-ness here when merging the auto ROI component (now deleted)
      Not happy with the multible draw functions, but it works for now.
      TODO: Simplify prop varibles and draw logic
    */

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    // Clear canvas before new crosses
    context.clearRect(0, 0, props.width, props.height);

    let ax1 = props.x1;
    let ay1 = props.y1;
    let ax2 = props.x2 - props.x1;
    let ay2 = props.y2 - props.y1;

    context.strokeStyle = "white";
    context.lineWidth = 2;
    context.strokeRect(ax1, ay1, ax2, ay2);
    //console.log(props.ax1, props.x1, props.ay1, props.y1, props.ax2, props.x2, props.ay2, props.y2);

    if(props.disableBox) {
      return;
    }

    const center = props.coordinates.centre;
    const lower_right = props.coordinates.lower_right;
    const lower_left = props.coordinates.lower_left;
    const upper_right = props.coordinates.upper_right;
    const upper_left = props.coordinates.upper_left;

    if (center) {
      //console.log("Draw Cords");
      context.lineWidth = 3;

      drawCross(context, center[0], center[1], "purple");
      drawCross(context, lower_right[0], lower_right[1], "green");
      drawCross(context, lower_left[0], lower_left[1], "yellow");
      drawCross(context, upper_right[0], upper_right[1], "red");
      drawCross(context, upper_left[0], upper_left[1], "blue");

      // Is the returned box the same as auto? Add the text back
      if (props.ax1 === props.x1 && props.ay1 === props.y1 && props.ax2 === props.x2 && props.ay2 === props.y2) {
        context.font = "16px sans-serif";
        var yTextOffset = ay1 - 8;
        context.fillStyle = "white";
        context.fillText(model_name, ax1, yTextOffset);
      }

    } else {
      // No Points, clear the canvas
      context.clearRect(0, 0, props.width, props.height);
    }

  }, [props.coordinates]);


  /* ******************************************************************************************* */
  function drawCross(context, x, y, color) {
    context.strokeStyle = color;
    context.beginPath();
    context.moveTo(x, y - 10);
    context.lineTo(x, y + 10);
    context.moveTo(x - 10, y);
    context.lineTo(x + 10, y);
    context.stroke();
  }


  /* ******************************************************************************************* */
  const handleMouseDown = React.useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    const canvas = canvasRef.current;

    var rectangle = e.target.getBoundingClientRect();

    startX = parseInt(e.clientX - rectangle.left);
    startY = parseInt(e.clientY - rectangle.top);

    startX = startX * canvas.width / canvas.clientWidth | 0;
    startY = startY * canvas.height / canvas.clientHeight | 0;

    isDown = true;
  }, []);


  /* ******************************************************************************************* */
  const handleMouseUp = React.useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    // the drag is over, clear the dragging flag
    isDown = false;

      props.func({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        auto_roi: false,
      });

    //console.log("Mouse Up w/h", props.width, props.height);
  }, []);


  /* ******************************************************************************************* */
  const handleMouseOut = React.useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    // the drag is over, clear the dragging flag
    isDown = false;
  }, []);


  /* ******************************************************************************************* */
  const handleMouseMove = React.useCallback((e) => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    e.preventDefault();
    e.stopPropagation();

    var rectangle = e.target.getBoundingClientRect();

    // if we're not dragging, just return
    if (!isDown) {
      return;
    }

    // get the current mouse position
    mouseX = parseInt(e.clientX - rectangle.left);
    mouseY = parseInt(e.clientY - rectangle.top);

    // clear the canvas
    context.clearRect(0, 0, props.width, props.height);

    /* // Handy logs, keeping for later fixes
    //console.log("Mouse Move w/h Props:", props.width, props.height, " State: ", canvasWidth, canvasHeight, "canvas:", canvas.width, canvas.height);
    if (mouseX < startX) {
      console.log("Bad X?");
    }

    if (mouseY < startY) {
      console.log("Bad Y?");
    }
    */

    // calculate the rectangle width/height based
    // on starting vs current mouse position
    var width = mouseX - startX;
    var height = mouseY - startY;

    x1 = startX;
    y1 = startY;
    x2 = mouseX;
    y2 = mouseY;

    // draw a new rect from the start position
    // to the current mouse position
    context.strokeStyle = "white";
    context.lineWidth = 2;
    context.strokeRect(startX, startY, width, height);
  }, []);


 /* ************************************************************************* */
  useEffect(() => {
    //console.log("UseEffect W/H", props.width, props.height);
    setCanvasHeight(props.height);
    setCanvasWidth(props.width);

  }, [props.width, props.height]);


/* ************************************************************************* */
  useEffect(() => {
    //console.log("disableBox W/H", props.disableBox);

    let mm = wrapperRef.current;
    if(props.disableBox) {
      mm.style.cursor = "wait";
      mm.style.pointerEvents = "none";
    } else {
      mm.style.cursor = "cross";
      mm.style.pointerEvents = "all";
    }

  }, [props.disableBox]);


/* ************************************************************************* */
	useEffect(() => {
    //console.log("Draw Auto?");

    const center = props.coordinates.centre;
    if (center) {
      return;
    }

		const canvas = canvasRef.current;
		const ctx = canvas.getContext("2d");

    let ax1 = props.ax1;
    let ay1 = props.ay1;
    let ax2 = props.ax2 - props.ax1;
    let ay2 = props.ay2 - props.ay1;

		ctx.strokeStyle = "white";
		ctx.lineWidth = 2;
		ctx.font = "16px sans-serif";
		ctx.clearRect(0, 0, props.width, props.height);
		ctx.strokeRect(ax1, ay1, ax2, ay2);
		var yTextOffset = ay1 - 8;
		ctx.fillStyle = "white";

    // TODO: Disable this for user ROI
		ctx.fillText(model_name, ax1, yTextOffset);

		// eslint-disable-next-line
	}, [props.ax1, props.ax2, props.ay1, props.ay2]);


/**************************************************** */
  return (
    <div
      id="canvas-wrapper"
      className={props.type}
      style={{ width: props.width, height: props.height }}
      ref={wrapperRef}
    >
      {props.img ?
        <img
          id="vnir-sat-img"
          src={props.img}
          alt="Vnir Saturation"
          className="imageScan"
          width={props.width}
          height={props.height}
        />
      : "Loading..."}
      <canvas
        id="vnir-sat-canvas"
        className={"canvas " + props.type}
        ref={canvasRef}
        width={props.width}
        height={props.height}

        onMouseMove={handleMouseMove}
        onMouseDown={handleMouseDown}
        onMouseOut={handleMouseOut}
        onMouseUp={handleMouseUp}
      />

    </div>
  );
}

export default VnirSatCanvas;
